import { render, staticRenderFns } from "./DownloadSeed.vue?vue&type=template&id=023dcbc5&scoped=true&"
import script from "./DownloadSeed.vue?vue&type=script&lang=ts&"
export * from "./DownloadSeed.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadSeed.vue?vue&type=style&index=0&id=023dcbc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023dcbc5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSnackbar,VTextField})
